import { render, staticRenderFns } from "./BespokeLies.vue?vue&type=template&id=6f05f164&scoped=true&"
import script from "./BespokeLies.vue?vue&type=script&lang=js&"
export * from "./BespokeLies.vue?vue&type=script&lang=js&"
import style0 from "./BespokeLies.vue?vue&type=style&index=0&id=6f05f164&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f05f164",
  null
  
)

export default component.exports